/*
 * RMA "Save your cart" — cart-drawer email capture.
 * Pairs with snippets/rma-cart-save.liquid.
 *
 * Submits the native Shopify customer (newsletter) form via AJAX so the drawer
 * doesn't reload, links the email to the Omnisend browser session via
 * omnisend.identifyContact (so Omnisend's browser-based Abandoned Cart automation
 * can reach this session), and remembers "saved" per browser so the prompt
 * doesn't nag a repeat visitor.
 *
 * Dawn re-renders the whole #CartDrawer wholesale on every cart change, so the
 * submit handler is delegated on document (submit bubbles) and a MutationObserver
 * re-applies the "already saved" state after each re-render.
 */
(function () {
  if (window.__rmaCartSaveInit) return;
  window.__rmaCartSaveInit = true;

  var SAVED_KEY = 'rma_cart_saved';
  var EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

  function isSaved() {
    try { return localStorage.getItem(SAVED_KEY) === '1'; } catch (e) { return false; }
  }
  function markSaved() {
    try { localStorage.setItem(SAVED_KEY, '1'); } catch (e) {}
  }

  // Tie the email to the current browser session so Omnisend's abandoned-cart
  // automation can reach it. Safe as a push-queue command whether or not the SDK
  // has finished loading.
  function identify(email) {
    try {
      window.omnisend = window.omnisend || [];
      window.omnisend.push(['identifyContact', { email: email }]);
    } catch (e) { /* non-fatal */ }
  }

  function showDone() {
    var wrap = document.querySelector('[data-rma-save]');
    if (!wrap) return;
    wrap.innerHTML =
      '<div class="rma-save__done">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>' +
      '<span>Cart saved &mdash; check your inbox for a reminder.</span>' +
      '</div>';
  }

  function applyState() {
    if (isSaved()) showDone();
  }

  function submitForm(form) {
    var input = form.querySelector('.rma-save__input');
    var btn = form.querySelector('.rma-save__btn');
    var msg = form.querySelector('[data-rma-save-msg]');
    if (!input) return;
    var email = (input.value || '').trim();

    function fail(text) {
      if (btn) { btn.disabled = false; btn.textContent = 'Save'; }
      if (!msg) return;
      msg.textContent = text;
      msg.classList.add('is-error');
      msg.hidden = false;
    }

    if (!EMAIL_RE.test(email)) { fail('Please enter a valid email address.'); input.focus(); return; }
    if (msg) { msg.hidden = true; msg.classList.remove('is-error'); }
    if (btn) { btn.disabled = true; btn.textContent = 'Saving…'; }

    var action = form.getAttribute('action') || '/contact';
    fetch(action, {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'text/html' }
    })
      .then(function (res) {
        // Shopify returns 2xx/redirect even for benign cases (e.g. already a
        // contact); a malformed email is already caught client-side, so a
        // completed non-server-error response means the email was captured.
        if (!res || res.status >= 500) throw new Error('server');
        identify(email);
        markSaved();
        showDone();
      })
      .catch(function () {
        fail("Couldn't save just now — please try again.");
      });
  }

  // Delegated submit survives the wholesale drawer re-render (submit bubbles).
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form && form.classList && form.classList.contains('rma-save__form')) {
      e.preventDefault();
      submitForm(form);
    }
  });

  function observe() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(applyState, 120);
    }).observe(drawer, { childList: true, subtree: true });
  }

  function init() { observe(); applyState(); }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
